<template>
  <div class="vehicle-list">
    <van-nav-bar title="车辆管理" fixed />
    <div class="content">
      <van-button type="primary" block @click="showEntry = true">车辆入场</van-button>
      <van-list v-model="loading" :finished="finished" @load="onLoad">
        <van-cell-group v-for="item in list" :key="item.id">
          <van-cell title="车牌号" :value="item.plateNumber" />
          <van-cell title="车主" :value="item.ownerName" />
          <van-cell title="电话" :value="item.ownerPhone" />
          <van-cell title="停车场" :value="item.parkingLotName" />
          <van-cell title="入场时间" :value="item.entryTime" />
          <van-cell>
            <template #default>
              <van-button size="small" type="warning" @click="handleExit(item.id)">出场</van-button>
            </template>
          </van-cell>
        </van-cell-group>
      </van-list>
    </div>

    <van-dialog v-model="showEntry" title="车辆入场" show-cancel-button @confirm="handleEntry">
      <van-form>
        <van-field v-model="form.plateNumber" label="车牌号" placeholder="请输入" required />
        <van-field v-model="form.ownerName" label="车主姓名" placeholder="请输入" required />
        <van-field v-model="form.ownerPhone" label="联系电话" placeholder="请输入" required />
        <van-field v-model="form.parkingLotId" label="停车场" placeholder="请选择" required />
      </van-form>
    </van-dialog>
  </div>
</template>

<script>
import { vehicleApi } from '@/api'

export default {
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      showEntry: false,
      form: {
        plateNumber: '',
        ownerName: '',
        ownerPhone: '',
        parkingLotId: ''
      }
    }
  },
  methods: {
    async onLoad() {
      try {
        const { data } = await vehicleApi.getList({ status: 'parked' })
        this.list = data
        this.finished = true
      } catch (error) {
        this.$toast.fail('加载失败')
      }
      this.loading = false
    },
    async handleEntry() {
      try {
        await vehicleApi.entry(this.form)
        this.$toast.success('入场成功')
        this.form = { plateNumber: '', ownerName: '', ownerPhone: '', parkingLotId: '' }
        this.onLoad()
      } catch (error) {
        this.$toast.fail('入场失败')
      }
    },
    async handleExit(id) {
      this.$dialog.confirm({ message: '确定车辆出场?' }).then(async () => {
        await vehicleApi.exit(id)
        this.$toast.success('出场成功')
        this.onLoad()
      })
    }
  }
}
</script>

<style scoped>
.vehicle-list {
  padding-top: 46px;
}
.content {
  padding: 16px;
}
.van-cell-group {
  margin-top: 12px;
}
</style>
